exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".default-topping[data-v-697d10c0],.extra-topping[data-v-697d10c0]{margin-left:5px;margin-top:8px;cursor:pointer}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/menu/ToppingForm.vue"],"names":[],"mappings":"AACA,kEAEE,gBAAiB,AACjB,eAAgB,AAChB,cAAgB,CACjB","file":"ToppingForm.vue","sourcesContent":["\n.default-topping[data-v-697d10c0],\n.extra-topping[data-v-697d10c0]{\n  margin-left: 5px;\n  margin-top: 8px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-697d10c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/admin/menu/ToppingForm.vue
// module id = 1557
// module chunks = 0